import { useState, useEffect } from "react";
import { client } from "@/utils/sanity";

export const useRoadMap = () => {
  const [roadMap, setRoadMap] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `*[_type == "roadmap"] | order(id)`;
        const roadMapData = await client.fetch(query);
        setRoadMap(roadMapData);
      } catch (error) {
        console.error("Error fetching roadmap:", error);
      }
    };

    fetchData();
  }, []);

  return roadMap;
};